import { createContext, useMemo, type PropsWithChildren } from "react";

import { useProposalDocumentsQuery } from "../hooks/useDocumentsApi";

import type { Carrier, CarrierProposal } from "../types";

export interface ProposalsContextValue {
  proposals: CarrierProposal[];
  loading: boolean;
  error: string | null;
  hasTimeout: boolean;
  clearTimeout: VoidFunction;
}

export const ProposalsContext = createContext<
  ProposalsContextValue | undefined
>(undefined);

interface ProposalsProviderProps {
  rfpId: string;
  carriers: Carrier[];
}

export function ProposalsProvider({
  children,
  rfpId,
  carriers,
}: PropsWithChildren<ProposalsProviderProps>): React.JSX.Element {
  const {
    proposals: fetchedProposals,
    loading,
    error,
    timeoutFlag,
    clearTimeoutFlag,
  } = useProposalDocumentsQuery(rfpId, carriers);

  const value = useMemo<ProposalsContextValue>(
    () => ({
      proposals: fetchedProposals,
      loading,
      error,
      hasTimeout: timeoutFlag,
      clearTimeout: clearTimeoutFlag,
    }),
    [fetchedProposals, loading, error, timeoutFlag, clearTimeoutFlag],
  );

  return (
    <ProposalsContext.Provider value={value}>
      {children}
    </ProposalsContext.Provider>
  );
}
